
export const environment = {
  production: false,
  SECRET_KEY: 'e5ac7dda0b5d2268a8c7cb15c55ade5d1a0ae8475f8e76bf41e9e8276c93b327',
  APP_NAME: 'Business Tour & Travel Expense Management System',
  API_URL: 'https://bttem.shyamfuture.in',
  REDIRECT_URL: 'https://sftwh-qa.shyamfuture.in',
  firebase: {
    apiKey: "AIzaSyADm9hIaQLKtZfS51fQM6_e6iFrz8nvokU",
    authDomain: "sft-travel-desk.firebaseapp.com",
    projectId: "sft-travel-desk",
    storageBucket: "sft-travel-desk.firebasestorage.app",
    messagingSenderId: "150819382826",
    appId: "1:150819382826:web:f2ed89946b7e96c097c553",
    measurementId: "G-JNTTK9XJKT"
  },
  vapidKey: "BO7T7hs7FxT_CUrhsDHFBMbCrI9cjd9r3ayHVBGOXeD85HQYbVZ3ZwYLi84_Z-kVPgE-SrcCX6auQlGdMya3yyE" 
};
